import React, { Component } from "react";
import { navigate } from "gatsby";
import { withFirebase } from "../../../../utils/Firebase";
import { PATH_OVERVIEW } from "../../../../constants/routes";
import Input from "../../../atoms/Input";
import Button from "../../../atoms/Button";
import { loginWeb } from "../../../../utils/API/endpoints";

const INITIAL_STATE = {
  email: "",
  password: "",
  error: null,
};

class SignInForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  firebaseInit = () => {
    if (this.props.firebase && !this._initFirebase) {
      this._initFirebase = true;
    }
  };

  componentDidMount() {
    this.firebaseInit();
  }

  componentDidUpdate() {
    this.firebaseInit();
  }

  onSubmit = (event) => {
    const { email, password } = this.state;
    this.props.firebase
      .doSignInWithEmailAndPassword(email, password)
      .then(() => {
        loginWeb(this.props.firebase);
        typeof window !== "undefined" && navigate(PATH_OVERVIEW);
      })
      .catch((error) => {
        if (process.env.GATSBY_ENV === "dev") {
          console.log(error.toString());
        }
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, password, error } = this.state;
    const isInvalid = password === "" || email === "";
    return (
      <>
        <form onSubmit={this.onSubmit}>
          <Input
            name="email"
            value={email}
            onChange={this.onChange}
            type="text"
            labelName="Epostadresse"
            styleOverride={{ padding: "4px", color: "rgb(117, 117, 117)" }}
            required
          />

          <Input
            name="password"
            value={password}
            onChange={this.onChange}
            type="password"
            labelName="Passord"
            styleOverride={{ padding: "4px", color: "rgb(117, 117, 117)" }}
            className="input--no-margin"
            required
          />

          <Button disabled={isInvalid} type="submit" text="Logg inn" />

          {error && (
            <p style={{ textAlign: "center" }}>
              Feil brukernavn og / eller passord.
            </p>
          )}
        </form>
      </>
    );
  }
}

export default withFirebase(SignInForm);
